module.exports = __webpack_public_path__ + "static/media/fishsteak.c1e85289.webp";